export class PccUser {
	orgId: number;

	orgUuid: string;

	username: string;

	sub: string;

	name: string;

	defaultFacId: number;

	enabled: boolean;

	userId: number;

	passwordExpired: boolean;

	privilegeScopes: string[];

	restrictedAccess: boolean;

	usageAnalyticsUserId: string;
}
